import { render } from "./EditPlatFormCostSetting.vue?vue&type=template&id=451eea1c&scoped=true"
import script from "./EditPlatFormCostSetting.vue?vue&type=script&lang=js"
export * from "./EditPlatFormCostSetting.vue?vue&type=script&lang=js"

import "./EditPlatFormCostSetting.vue?vue&type=style&index=0&id=451eea1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451eea1c"]])

export default __exports__